import { render, staticRenderFns } from "./xiantu.vue?vue&type=template&id=1a571c94&scoped=true"
import script from "./xiantu.vue?vue&type=script&lang=js"
export * from "./xiantu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a571c94",
  null
  
)

export default component.exports